import Area from "@/domain/Area";
import Region from "@/domain/Region";
import * as AccountTypes from "@/enums/account.type";
import * as Clients from "@/enums/client";
import * as Performs from '@/enums/perform.type'
import * as Permissions from '@/enums/permission'
import * as HistoryTypes from "@/enums/history.type";
import Mail from "@/domain/Mail";
import _ from 'underscore'
import Perform from "@/domain/Perform";
import Moment from 'moment'
import PrintPackage from "@/domain/PrintPackage";
import PostPackage from "@/domain/PostPackage";
import PostIndex from "@/domain/PostIndex";
import Login from "@/domain/Login";
import Account from "@/domain/Account";
import PostPackageGroup from "@/domain/PostPackageGroup";
import MailHistory from "@/domain/MailHistory";
import Registry from "@/domain/Registry";
import TempMail from "@/domain/TempMail";
import RegistryMail from "@/domain/RegistryMail";
import PostIndexWithChilds from "@/domain/PostIndexWithChilds";
import Transfer from "@/domain/Transfer";
import Unit from "@/domain/Unit";

let mapRegistryViewModel = registryViewModel => {
    if (registryViewModel) {
        let registry = new Registry()

        registry.id = registryViewModel.Id
        registry.client = mapClient(registryViewModel.ClientType)
        registry.note = registryViewModel.Note
        registry.createdOn = Moment(registryViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss')
        registry.mailsCount = registryViewModel.MailsCount

        return registry
    }

    return null
}

let mapTempMail = mailViewModel => {
    let mail = new TempMail()

    mail.id = mailViewModel.Id;
    mail.uid = mailViewModel.Uid;
    mail.client = mapClient(mailViewModel.ClientType);
    mail.area = mapAreaViewModel(mailViewModel.Area);
    mail.region = mapRegionViewModel(mailViewModel.Region);
    mail.pagesCount = mailViewModel.PagesCount;
    mail.address = mailViewModel.Address;
    mail.receiver = mailViewModel.Receiver;
    mail.createdOn = Moment(mailViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
    mail.isApproved = mailViewModel.IsApproved
    mail.approvedOn = mailViewModel.ApprovedOn ? Moment(mailViewModel.ApprovedOn, 'YYYY-MM-DD HH-mm-ss') : null;

    return mail
}

let mapRegistryMail = registryMailViewModel => {
    let registryMail = new RegistryMail()

    registryMail.id = registryMailViewModel.Id;
    registryMail.mail = registryMailViewModel.Mail ? mapMailViewModel(registryMailViewModel.Mail) : null;
    registryMail.tempMail = mapTempMail(registryMailViewModel.TempMail);
    registryMail.registryId = registryMailViewModel.RegistryId;
    registryMail.content = JSON.parse(registryMailViewModel.ContentJson);

    return registryMail
}

let mapAreaViewModel = (areaViewModel) => {
    let area = new Area()

    area.id = areaViewModel.Id;
    area.name = areaViewModel.Name;
    if (areaViewModel.Region != null)
    {
        area.region = mapRegionViewModel(areaViewModel.Region);
    }
    // return new Area(areaViewModel.Id, areaViewModel.Name)
    return area
}

let mapRegionViewModel = regionViewModel => {
    return new Region(regionViewModel.Id, regionViewModel.Name)
}

let mapClient = (clientType) => {
    let keys = _.keys(Clients)
    let clientKey = _.find(keys, key => {
        return Clients[key].id === clientType;
    })

    return Clients[clientKey];
}

let mapUnit = (unitViewModel) => {
    let unit = new Unit()

    unit.id = unitViewModel.Id;
    unit.name = unitViewModel.Name;
    unit.clientType = mapClient(unitViewModel.ClientType);
    unit.clientCode = unitViewModel.ClientCode;
    unit.organizationId = unitViewModel.OrganizationId;
    unit.branchId = unitViewModel.BranchId;

    return unit
}

let mapHistoryType = historyType => {
    let keys = _.keys(HistoryTypes)
    let historyTypeKey = _.find(keys, key => {
        return HistoryTypes[key].id === historyType;
    })

    return HistoryTypes[historyTypeKey];
}

let mapPerformType = (performType) => {
    let keys = _.keys(Performs)
    let performKey = _.find(keys, key => {
        return Performs[key].id === performType;
    })

    return Performs[performKey];
}

let mapPerform = (performViewModel) => {
    if (performViewModel) {
        let perform = new Perform()

        perform.id = performViewModel.Id;
        perform.createdOn = Moment(performViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
        perform.performedOn = Moment(performViewModel.PerformedOnStr, 'YYYY-MM-DD HH-mm-ss');
        perform.note = performViewModel.Note;
        perform.performType = mapPerformType(performViewModel.Type)
        perform.notifiedOn = performViewModel.NotifiedOn

        return perform
    }
    return null
}

let mapPrintPackageViewModel = (printPackageViewModel) => {
    if (printPackageViewModel) {
        let printPackage = new PrintPackage()

        printPackage.id = printPackageViewModel.Id;
        printPackage.uid = printPackageViewModel.Uid;
        printPackage.createdOn = Moment(printPackageViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
        printPackage.client = mapClient(printPackageViewModel.ClientType);
        printPackage.account = mapAccountViewModel(printPackageViewModel.Account)
        printPackage.region = mapRegionViewModel(printPackageViewModel.Region)
        printPackage.area = printPackageViewModel.Area ? mapAreaViewModel(printPackageViewModel.Area) : null
        printPackage.mailsCount = printPackageViewModel.MailsCount
        printPackage.packedMailsCount = printPackageViewModel.PackedMailsCount

        return printPackage
    }
    return null
}

let mapPostPackageViewModel = (postPackageViewModel) => {
    if (postPackageViewModel) {
        let postPackage = new PostPackage()

        postPackage.id = postPackageViewModel.Id;
        postPackage.uid = postPackageViewModel.Uid;
        postPackage.createdOn = Moment(postPackageViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
        postPackage.client = mapClient(postPackageViewModel.ClientType);
        postPackage.postCode = postPackageViewModel.PostCode
        postPackage.courier = postPackageViewModel.CourierName
        postPackage.region = postPackageViewModel.Region ? mapRegionViewModel(postPackageViewModel.Region) : null
        postPackage.account = postPackageViewModel.Account ? mapAccountViewModel(postPackageViewModel.Account) : null
        postPackage.postIndex = postPackageViewModel.PostIndex ? mapPostIndexViewModel(postPackageViewModel.PostIndex) : null
        postPackage.postPackageGroup = postPackageViewModel.PostPackageGroup ? mapPostPackageGroupViewModel(postPackageViewModel.PostPackageGroup) : null
        postPackage.mailsCount = postPackageViewModel.MailsCount
        postPackage.performedMailsCount = postPackageViewModel.PerformedMailsCount
        postPackage.tryPerformedMailsCount = postPackageViewModel.TryPerformMailsCount

        return postPackage
    }

    return null
}

let mapPostPackageGroupViewModel = (postPackageGroupViewModel) => {
    if (postPackageGroupViewModel) {
        let postPackageGroup = new PostPackageGroup()

        postPackageGroup.id = postPackageGroupViewModel.Id;
        postPackageGroup.uid = postPackageGroupViewModel.Uid;
        postPackageGroup.createdOn = Moment(postPackageGroupViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
        postPackageGroup.postCode = postPackageGroupViewModel.PostCode
        postPackageGroup.region = postPackageGroupViewModel.Region ? mapRegionViewModel(postPackageGroupViewModel.Region) : null
        postPackageGroup.account = postPackageGroupViewModel.Account ? mapAccountViewModel(postPackageGroupViewModel.Account) : null
        postPackageGroup.postIndex = postPackageGroupViewModel.PostIndex ? mapPostIndexViewModel(postPackageGroupViewModel.PostIndex) : null

        return postPackageGroup
    }

    return null
}

let mapPostIndexViewModel = (postIndexViewModel) => {
    if (postIndexViewModel) {
        let postIndex = new PostIndex(
            postIndexViewModel.Id,
            postIndexViewModel.PostCode,
            postIndexViewModel.Name,
            postIndexViewModel.PostRegionCode,
            postIndexViewModel.PostDistrictCode,
            postIndexViewModel.IsActive
        )
        if (postIndexViewModel.Parent)
            postIndex.parent = mapPostIndexViewModel(postIndexViewModel.Parent)

        return postIndex
    }

    return null
}

let mapPostIndexWithChildsViewModel = (postIndexViewModel) => {
    if (postIndexViewModel) {
        let vm = new PostIndexWithChilds(
            postIndexViewModel.Id, postIndexViewModel.PostCode, postIndexViewModel.Name,
            postIndexViewModel.PostRegionCode, postIndexViewModel.PostDistrictCode, postIndexViewModel.IsActive
        )
        vm.childs = _.map(postIndexViewModel.Childs, child => {
            return mapPostIndexViewModel(child)
        })
        return vm
    }

    return null
}

let mapAccountType = (accountType) => {
    let keys = _.keys(AccountTypes)
    let accountTypeKey = _.find(keys, key => {
        return AccountTypes[key].id === accountType;
    })

    return AccountTypes[accountTypeKey];
}

let mapLoginViewModel = (loginViewModel) => {
    if (loginViewModel) {
        let permissionKeys = Object.keys(Permissions)
        const permissions = _.map(permissionKeys, pk => {
            return Permissions[pk]
        })

        let login = new Login()

        login.id = loginViewModel.Id;
        login.name = loginViewModel.Name;
        login.username = loginViewModel.Username;
        login.postIndex = loginViewModel.PostIndex;
        login.type = mapAccountType(loginViewModel.Type)
        login.permissions = _.map(loginViewModel.Permissions, p => {
            return _.find(permissions, perm => {
                return perm.id === p
            })
        });
        login.regions = _.map(loginViewModel.Regions, r => {
            return mapRegionViewModel(r)
        });
        login.areas = _.map(loginViewModel.Areas, a => {
            return mapAreaViewModel(a)
        });

        return login
    }

    return null
}

let mapAccountViewModel = (accountViewModel) => {
    if (accountViewModel) {
        let account = new Account()

        account.id = accountViewModel.Id;
        account.name = accountViewModel.Name;
        account.username = accountViewModel.Username;
        account.postIndex = accountViewModel.PostIndex;
        account.type = accountViewModel.Type;

        if (accountViewModel.Childs) {
            account.childs = _.map(accountViewModel.Childs, c => {
                return mapAccountViewModel(c)
            })
        }

        return account
    }

    return null
}

let mapMailViewModel = mailViewModel => {
    let mail = new Mail();

    mail.id = mailViewModel.Id;
    mail.uid = mailViewModel.Uid;
    mail.client = mapClient(mailViewModel.ClientType);
    mail.area = mapAreaViewModel(mailViewModel.Area);
    mail.region = mapRegionViewModel(mailViewModel.Region);
    mail.pagesCount = mailViewModel.PagesCount;
    mail.address = mailViewModel.Address;
    mail.receiver = mailViewModel.Receiver;
    mail.createdOn = Moment(mailViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
    mail.perform = mapPerform(mailViewModel.Perform)
    mail.printPackage = mapPrintPackageViewModel(mailViewModel.PrintPackage)
    mail.postPackage = mapPostPackageViewModel(mailViewModel.PostPackage)
    mail.isExpress = mailViewModel.IsExpress
    mail.postIndex = mapPostIndexViewModel(mailViewModel.PostIndex)
    mail.transfer = mapTransfer(mailViewModel.Transfer)

    return mail;
}

let mapTransfer = transfer => {
    if (transfer) {
        let transferViewModel = new Transfer()

        transferViewModel.id = transfer.Id;
        transferViewModel.createdOn = Moment(transfer.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
        transferViewModel.clientOrderId = transfer.ClientOrderId;
        transferViewModel.isNotified = transfer.IsNotified;
        transferViewModel.notifiedOn = Moment(transfer.NotifiedOnStr, 'YYYY-MM-DD HH-mm-ss')
        transferViewModel.isCompleted = transfer.IsCompleted;
        transferViewModel.completedOn = Moment(transfer.CompletedOnStr, 'YYYY-MM-DD HH-mm-ss')

        return transferViewModel;
    }

    return null
}

let mapMailHistoryViewModel = mailHistoryViewModel => {
    let mailHistory = new MailHistory();

    mailHistory.id = mailHistoryViewModel.Id;
    mailHistory.createdOn = Moment(mailHistoryViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
    mailHistory.type = mapHistoryType(mailHistoryViewModel.HistoryType);
    mailHistory.account = mapAccountViewModel(mailHistoryViewModel.Account);
    mailHistory.postIndex = mailHistoryViewModel.PostIndex;
    mailHistory.printPackageUid = mailHistoryViewModel.PrintPackageUid;
    mailHistory.postPackageUid = mailHistoryViewModel.PostPackageUid;
    mailHistory.perform = mapPerform(mailHistoryViewModel.Perform);
    mailHistory.postPackagePostCode = mailHistoryViewModel.PostPackagePostCode
    mailHistory.transfer = mapTransfer(mailHistoryViewModel.Transfer)
    mailHistory.mailSendHistory = mailHistoryViewModel.MailSendHistory;

    return mailHistory
}

export default {
    mapMail: mapMailViewModel,
    mapRegion: mapRegionViewModel,
    mapArea: mapAreaViewModel,
    mapPostIndex: mapPostIndexViewModel,
    mapPostIndexWithChilds: mapPostIndexWithChildsViewModel,
    mapLogin: mapLoginViewModel,
    mapAccount: mapAccountViewModel,
    mapPrintPackage: mapPrintPackageViewModel,
    mapPostPackage: mapPostPackageViewModel,
    mapPostPackageGroup: mapPostPackageGroupViewModel,
    mapMailHistory: mapMailHistoryViewModel,
    mapRegistry: mapRegistryViewModel,
    mapRegistryMail: mapRegistryMail,
    mapTempMail: mapTempMail,
    mapClient: mapClient,
    mapUnit: mapUnit,
}
